import { getProductWithVariants, ProductWithVariants } from '@models/product';
import { billingAddress, paymentData, submitContract } from '@config/order-step-configs';
import { HandyLandingComponent } from '../landing-pages/handy-landing/handy-landing.component';
import { electronicsB2CDevice, productAdviceHandy } from './steps';
import { InsuredDeviceWidgetComponent } from 'app/products/electronic/widgets/insured-device-widget/insured-device-widget.component';
import { ElectronicsB2CInformationWidgetComponent } from 'app/products/electronic/widgets/electronics-b2c-information/electronics-b2c-information-widget.component';
import { electronicsB2CProduct } from './electronics-b2c-product.config';
import { electronicDamageReportSteps } from './damage-report-steps';

export const handyProduct: ProductWithVariants = getProductWithVariants({
    ...electronicsB2CProduct,
    slug: 'handyversicherung',
    title: 'Handyversicherung',
    fullTitle: 'Handyversicherung ohne Selbstbeteiligung mit Diebstahlschutz',
    insuranceTypeName: 'Elektronikversicherung B2C (J)',
    insuranceTypeId: 29,
    orderConfig: {
        steps: [
            {
                slug: '',
                title: '',
                component: HandyLandingComponent,
            },
            electronicsB2CDevice,
            productAdviceHandy,
            billingAddress,
            paymentData,
            submitContract,
        ],
        taxInfo: 'Inkl. 19 % Versicherungssteuer',
        hasFlexPrice: true,
        requiresMedicalData: false,
        requiresNoPriorDefect: true,
        showDiscountInput: true,
        showPriceFrom: false,
        hideSummarySidebarOnLandingPage: true,
        headerMode: 'default',
    },
    portalConfig: {
        icon: 'smartphone',
        iconSize: '48px',
        widgets: [{ component: ElectronicsB2CInformationWidgetComponent }, { component: InsuredDeviceWidgetComponent }],
        damageReportSteps: electronicDamageReportSteps,
    },
    presentation: {
        description: `
            <p class="fw:semibold">
                Schütze deinen treuen Begleiter und Helfer im Alltag mit der astra Handyversicherung.
            </p>
            <p>
                Du kannst dir ein Leben ohne Smartphone nicht mehr vorstellen und hast den Alleskönner in jeder Situation parat?
                Umso größer ist natürlich die Gefahr, dass das Display durch einen Sturz kaputt geht oder das Handy gestohlen wird.
                Mit unserer Handyversicherung für dein iPhone, Samsung und andere Marken jeglicher Art sicherst du dich ab und musst
                für kleines Geld im Schadensfall nicht wieder auf dein Erspartes zurückgreifen.
            </p>
        `,
        bulletPoints: [
            'Schnelle Schadensabwicklung',
            'Diebstahlschutz optional',
            'Keine Mindestlaufzeit',
            'Tägliche Kündigungsfrist',
        ],
        imageUrl: 'assets/img/product-headers/astra-Versicherung-Handyversicherung.jpg',
        imageAlt: 'Handy ohne Selbstbeteiligung versichern',
        imageHeadline: '<span class="h3 m-0:b">Weil wir uns um den besten Schutz kümmern.</span>',
        docIPIDUrl: 'astra_IPID_Elektronik_Endkunden_EV_MD_2026.pdf',
        docAVBUrl: 'astra_AVB_Elektronik_Endkunden_EV_MD_2026.pdf',
        docAddInfoUrl: 'astra_Kundeninfo_Elektronik_Endkunden_EV_MD_2026.pdf',
        docAnzeigepflichtUrl: 'Obliegenheiten_und_vorvertragliche_Anzeigepflicht.pdf',
        meta: {
            title: 'Handyversicherung - Weltweiter Schutz ohne Wartezeit',
            description:
                'Inkl. Diebstahlschutz ✓ Super Preis-Leistungs-Verhältnis ✓ Weltweit ✓ Sofortschutz ✓ Schnelle Schadensabwicklung ✓ Digitaler Abschluss ✓',
        },
    },
    insuredObjectsForm: {
        headline: 'Zu versicherndes Gerät',
        description: '',
        objectDescriptionSingular: 'Gerät',
        max: 1,
        controls: [
            {
                name: 'description',
                label: 'Hersteller',
                type: 'text',
            },
            {
                name: 'model',
                label: 'Modell',
                type: 'text',
            },
            {
                name: 'value',
                label: 'Kaufpreis',
                type: 'value',
            },
            {
                name: 'detail',
                label: 'IMEI',
                type: 'text',
            },
        ],
    },
    variants: electronicsB2CProduct.variants.map(({ condition, overrides }) => ({
        condition,
        overrides: {
            ...overrides,
            slug: overrides.slug?.replace('elektronikversicherung', 'handyversicherung'),
            fullTitle: overrides.fullTitle?.replace('Elektronikversicherung', 'Handyversicherung'),
            collapsableTitle: overrides.fullTitle?.replace('Elektronikversicherung', 'Handyversicherung'),
        },
    })),
});
